import { getPanoramaClient } from './panorama';

export type InteractionKey = 'category-switch';
let loadStarted = false;
let loadFinished = false;

export const startMonitoring = () => {
  const client = getPanoramaClient();
  if (client && !loadStarted) {
    client.reportLoadStart();
    loadStarted = true;
  }
};

export const monitoring = {
  appLoaded: () => {
    if (!loadStarted || loadFinished) {
      return;
    }
    getPanoramaClient()?.reportLoadFinish();
    loadFinished = true;
  },
  interactionStarted: (key: InteractionKey) =>
    getPanoramaClient()?.transaction(key).start(),
  interactionEnded: (key: InteractionKey) =>
    getPanoramaClient()?.transaction(key).finish(),
};
